// extracted by mini-css-extract-plugin
export default {"product__card":"ProductCard_product__card__iTp02","product__title":"ProductCard_product__title__1x78K"};